import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deleteLocation: [],
  loading: false,
  error: null,
};

const deleteLocationSlice = createSlice({
  name: "deleteLocation",
  initialState,
  reducers: {
    fetchDeleteLocationSuccess: (state, action) => {
      state.loading = false;
      state.deleteLocation = action.payload;
    },

    fetchDeleteLocationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchDeleteLocationSuccess,
  fetchDeleteLocationFailure,
} = deleteLocationSlice.actions;

export default deleteLocationSlice.reducer;